import { PaletteColor, PaletteColorOptions, createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    liteColor: {
      foreColor: PaletteColor;
      backColor: PaletteColor;
    };
    darkColor: {
      foreColor: PaletteColor;
      backColor: PaletteColor;
    };
  }
  interface PaletteOptions {
    liteColor?: {
      foreColor?: PaletteColorOptions;
      backColor?: PaletteColorOptions;
    };
    darkColor?: {
      foreColor?: PaletteColorOptions;
      backColor?: PaletteColorOptions;
    };
  }

  // PaletteColorOptions is a union type alias, so the extra swatches have to be
  // declared on SimplePaletteColorOptions, which is the interface behind it.
  interface SimplePaletteColorOptions {
    medium?: string;
    tableHeader?: string;
    tableRowAdd?: string;
    tableRowEven?: string;
  }

  interface PaletteColor {
    medium?: string;
    tableHeader?: string;
    tableRowAdd?: string;
    tableRowEven?: string;
  }
}

export const theme = createTheme({
  typography: {
    fontFamily: '"Barlow Condensed", sans-serif',
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  palette: {
    liteColor: {
      foreColor: {
        main: "#255dcd", // 主要な背景色
        light: "#87E5FF", // 明るいバリエーション
        dark: "#223a6f", // 暗いバリエーション
      },
      backColor: {
        main: "#F0F2F5", // 主要な背景色
        light: "#FFF", // 明るいバリエーション
        medium: "#dcdcdc",
        dark: "#202226", // 暗いバリエーション
        tableHeader: "#4B4B4B",
        tableRowAdd: "#F0F2F5",
        tableRowEven: "#dcdcdc",
      },
    },
    darkColor: {
      foreColor: {
        main: "#2aa3df", // 主要な背景色
        light: "#87E5FF", // 明るいバリエーション
        dark: "#2c658e", // 暗いバリエーション
      },
      backColor: {
        main: "#2F3137", // 主要な背景色
        light: "#37393F", // 明るいバリエーション
        dark: "#202226", // 暗いバリエーション
        tableHeader: "#202226",
        tableRowAdd: "##37393F",
        tableRowEven: "#2F3137",
      },
    },
  },
});
